import { CustomToastrAction, toastr } from "@/imports-files/common/common";
import { CandidateListAction } from "@/services/components/candidate-listing-action";

export async function bulkDownloadCV(setCandidateBulkActionModal, setApiError)
{
    var candidate_ids            =      getSelectedCandidateId();
    var body                     =      { 'candidate_ids': candidate_ids};
    var result                   =      await new CandidateListAction().downloadCandidateResumes(body);
    const customToastrAction     =      new CustomToastrAction();
    setApiError(result.request);

    if(result.status == 204)
    {
        // toastr.success('No CVs available for download.');
        customToastrAction.setNormalToastr('No CVs available for download', 'success'); 
    }
    else
    {
        if(result.data.type == "application/zip")
        {
            await saveAs(result.data, `Resumes.zip`);
        }
        else
        {
            await saveAs(result.data, `Resume.${result.data.type.split('/')[1]}`);
        } 
    }

    setCandidateBulkActionModal(false);
    deselectAllCandidates();
}

export function bulkSendGDPREmail()
{
    console.log('send gdpr email');
}

export async function bulkAddToJob(setCandidateAddToJobModal, setSelectedCandidateId)
{
    var candidate_ids = getSelectedCandidateId();
    setSelectedCandidateId(candidate_ids)
    setCandidateAddToJobModal(true);
}

export async function bulkDeleteCandidate(setcandidateJobDeleteModal, setSelectedCandidateId, setCandidateBulkActionModal)
{
    var candidate_ids = getSelectedCandidateId();
    setSelectedCandidateId(candidate_ids)
    setcandidateJobDeleteModal(true);
    setCandidateBulkActionModal(false);
    deselectAllCandidates();
}

export async function buldSendGDPREmail()
{
    // TODO :- Need to send email
    console.log('Next sprint')
}

export function getSelectedCandidateId()
{
    var all_body_checkbox = document.querySelectorAll('.rdt_TableRow input[type="checkbox"]');
    var selected_candidate = []; 

    for( var element of all_body_checkbox)
    {
        if(element.checked)
        {
            selected_candidate.push(element.closest('.rdt_TableRow').querySelector('.DotsOptionsCandi').id);
        }
    }

    return selected_candidate;
}


export function deselectAllCandidates()
{
    var all_checkbox = document.querySelector('[name = select-all-rows]')

    if(all_checkbox.checked)
    {
        all_checkbox.click();
    }
    else
    {
        all_checkbox.click();
        all_checkbox.click();
    }
}